<template>
  <div id="user-profile">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="d-inline-flex align-center">
            <h4>Bonjour </h4> &nbsp; <h3 class="blue--text"> {{ modelObject.email }}</h3>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="d-inline-flex align-center">
            <h6 class="display-1">Vos information personnelles</h6>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field label="Nom:"
            v-model="modelObject.last_name"
            v-on:change="updateModelObject(modelObject)"
          />
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field label="Prénom:"
            v-model="modelObject.first_name"
            v-on:change="updateModelObject(modelObject)"
          />
        </v-flex>
        <v-flex xs12 sm6>
          <v-radio-group v-model="modelObject.gender" :mandatory="false" row
            v-on:change="updateModelObject(modelObject)"
          >
            <v-radio label="Femme" value="F"></v-radio>
            <v-radio label="Homme" value="M"></v-radio>
          </v-radio-group>
        </v-flex>

       
        
        
      </v-layout>
    </v-container>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import session from '../api/session';

export default {
  // permet d'accéder au store
  // computed: {
  //   // https://stackoverflow.com/questions/45594244/vuex-namespaced-mapstate-with-multiple-modules
  //   ...mapState('whoami', [
  //     'pk',
  //     'username',
  //     'email',
  //     'first_name',
  //     'last_name',
  //   ]),
  //   ...mapState('password', [
  //     'changePasswdError',
  //     'changePasswdRaisonError',
  //   ])
  // },
  computed: mapState('whoami', [
    'pk',
    'username',
    'email',
    'first_name',
    'last_name',
  ]),
  
  data: function() {
    return {
      api_url: '/api/user/',
      // api_url: '/api/user/2/',
      modelObject: { },
    }
  },
  methods: {
    getModelObject() {
      var req_url = this.api_url  + this.pk
      session.get(req_url)
        .then((response) => {
          this.modelObject = response.data;
          this.isLoading = false;
          console.log('GET CALLED : ' + req_url);
          console.log(response)
        })
        .catch((err) => {
          this.isLoading = false;
          if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log('======= getModelObject error in response =======')
          console.log(err.response.data);
          console.log(err.response.status);
          console.log(err.response.headers);
          } else if (err.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log('======= getModelObject error in request =======')
          console.log(err.request);
          } else {
          // Something happened in setting up the request that triggered an Error
          console.log('======= getModelObject error in else =======')
          console.log('Err', err.message);
          }
        })
    },
    updateModelObject: function(postedObject) {
      this.isLoading = true;
      var req_url = this.api_url  + this.pk + '/'
      console.log("Changement sur l'objet : " + this.pk);
      console.log(postedObject)
      // gestion de la protection csrf :
      // session.defaults.xsrfCookieName = 'csrftoken'
      // session.defaults.xsrfHeaderName = 'X-CSRFToken'
      session.put(req_url, postedObject)
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log('======= updateModelObject error in response =======')
          console.log(err.response.data);
          console.log(err.response.status);
          console.log(err.response.headers);
          } else if (err.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log('======= updateModelObject error in request =======')
          console.log(err.request);
          } else {
          // Something happened in setting up the request that triggered an Error
          console.log('======= updateModelObject error in else =======')
          console.log('Err', err.message);
          }
        })
    },
    

  },
  mounted: function() {
      console.log('---- Mounted called master ----> '+ this.api_url + this.pk)
      this.getModelObject();
  },
  
}
</script>
